import React from 'react';

const DomainSidebar = ({
  domains,
  selectedDomainId,
  onSelectDomain,
  getDomainProgress,
  submissionStatus,
  isCollapsed,
  setIsCollapsed,
  selectedProgress,
  isLocked,
  darkMode,
  theme,
}) => {
  return (
    <div className={`sticky top-0 z-40 mb-5 rounded-lg shadow ${theme.panel}`}>
      <div className={`p-4 border-b ${theme.panelMuted}`}>
        <div className="flex items-center justify-between gap-3">
          <h2 className={`font-bold ${theme.heading}`}>Assigned COBIT Processes</h2>
          <button
            type="button"
            onClick={() => setIsCollapsed((p) => !p)}
            className="px-3 py-2 rounded-lg bg-orange-600 hover:bg-orange-700 text-white text-sm font-semibold transition"
          >
            {isCollapsed ? 'Show Processes' : 'Hide Processes'}
          </button>
        </div>
      </div>

      {!isCollapsed && (
        <div className="p-3 flex flex-wrap gap-2">
          {domains.map((domain) => {
            const p = getDomainProgress(domain.id);
            const selected = selectedDomainId === domain.id;
            const submitted = submissionStatus[domain.id] === 'submitted';

            const baseClass = darkMode
              ? 'bg-gray-800 border-gray-700 hover:border-orange-500 text-gray-100'
              : 'bg-white border-gray-300 hover:border-orange-600 text-gray-900';

            const selectedClass = darkMode
              ? 'bg-orange-900/30 border-orange-500 text-white'
              : 'bg-orange-100 border-orange-600 text-gray-900';

            const submittedClass = darkMode
              ? 'bg-green-900/20 border-green-600 text-green-100 hover:border-green-500'
              : 'bg-green-50 border-green-500 text-green-900 hover:border-green-600';

            const fullTitle = domain?.title ? `${domain.code} - ${domain.title}` : `${domain.code}`;

            return (
              <button
                key={domain.id}
                onClick={() => onSelectDomain(domain.id)}
                title={fullTitle} // hover tooltip with full process title
                className={`group px-3 py-2 rounded-lg border text-left text-sm transition min-w-[130px] max-w-[170px] ${
                  submitted ? submittedClass : selected ? selectedClass : baseClass
                }`}
                aria-label={fullTitle}
              >
                <div className="flex items-start justify-between gap-2">
                  <div className="min-w-0">
                    {/* show only process code by default */}
                    <div className="font-semibold leading-tight truncate">
                      {domain.code}
                    </div>

                    <div className={`text-xs mt-1 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                      {p.answered}/{p.total}
                    </div>
                  </div>

                  {submitted && (
                    <span
                      className={`text-[10px] px-2 py-0.5 rounded-full font-bold whitespace-nowrap ${
                        darkMode ? 'bg-green-800 text-green-100' : 'bg-green-100 text-green-800'
                      }`}
                    >
                      Submitted
                    </span>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      )}

      <div className="p-4">
        <p className={`text-sm mb-2 ${theme.mutedText}`}>
          Progress: <strong>{selectedProgress.answered}/{selectedProgress.total}</strong> ({selectedProgress.percentage}%)
        </p>
        <div className={`w-full rounded-full h-3 overflow-hidden ${theme.progressTrack}`}>
          <div
            className={`h-3 transition-all duration-500 ${
              selectedProgress.percentage < 40
                ? 'bg-red-500'
                : selectedProgress.percentage < 70
                ? 'bg-yellow-500'
                : 'bg-green-600'
            }`}
            style={{ width: `${selectedProgress.percentage}%` }}
          />
        </div>
        <div className="mt-2 text-xs">{isLocked ? '✅ Submitted' : '📝 Draft'}</div>
      </div>
    </div>
  );
};

export default DomainSidebar;